import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Avatar,
  Snackbar,
  Alert,
} from "@mui/material";
import { subscribeEmail } from "../api";

export default function EmailSignup() {
  const [email, setEmail] = useState("");
  const [loading, setLoad] = useState(false);
  const [toast, setToast] = useState({ open: false, msg: "", type: "success" });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    try {
      setLoad(true);
      await subscribeEmail(email.trim());
      setToast({
        open: true,
        msg: "Thanks – you're on the list!",
        type: "success",
      });
      setEmail("");
    } catch (err) {
      setToast({
        open: true,
        msg: err.message || "Subscription failed",
        type: "error",
      });
    } finally {
      setLoad(false);
    }
  };

  return (
    <>
      {/* full‑width bar with divider and subtle hover tint */}
      <Box
        sx={{
          px: { xs: 1.5, sm: 2 },
          py: { xs: 1, sm: 0.75 },
          mb: 1,
          borderBottom: 1,
          borderColor: "divider",
          backgroundColor: "rgba(255,255,255,0.03)",
          "&:hover": { backgroundColor: "rgba(255,255,255,0.05)" },
        }}
      >
        {/*   **inner flex wrapper** – auto width + centred  */}
        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{
            mx: "auto", // ← centres the whole group
            maxWidth: 500, // ← keep it compact on desktop
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: "center",
            justifyContent: "center",
            gap: { xs: 1.25, sm: 1.75 },
          }}
        >
          {/*  icon + title  */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              flexShrink: 0,
            }}
          >
            <img
              src="/logo.ico"
              alt="App logo"
              style={{
                width: 18,
                height: 18,
                filter: "brightness(0) invert(1)",
              }}
            />
            <Typography sx={{ fontWeight: 700, fontSize: "0.9rem" }}>
              Stay up to date
            </Typography>
          </Box>

          {/*  input + button  */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              width: { xs: "100%", sm: "auto" }, // full‑width on mobile, auto on desktop
            }}
          >
            <TextField
              type="email"
              required
              size="small"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={loading}
              sx={{
                width: { xs: "100%", sm: 260 }, // fixed 260 px so group stays centred
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                  backgroundColor: "rgba(255,255,255,0.02)",
                  "& fieldset": { borderColor: "rgba(255,255,255,0.1)" },
                  "&:hover fieldset": { borderColor: "rgba(255,255,255,0.25)" },
                  "&.Mui-focused fieldset": { borderColor: "primary.main" },
                },
              }}
            />

            <Button
              type="submit"
              variant="contained"
              disabled={loading}
              sx={{
                px: 2.5,
                fontWeight: 600,
                textTransform: "none",
                boxShadow: "none",
                flexShrink: 0,
              }}
            >
              {loading ? "…" : "Subscribe"}
            </Button>
          </Box>
        </Box>
      </Box>

      {/* reusable toast feedback */}
      <Snackbar
        open={toast.open}
        autoHideDuration={2500}
        onClose={() => setToast({ ...toast, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setToast({ ...toast, open: false })}
          severity={toast.type}
          sx={{ width: "100%" }}
        >
          {toast.msg}
        </Alert>
      </Snackbar>
    </>
  );
}
